<div class="loginNewPage">
  <!-- <div id="overlaySpinner" style="display:none;">
    <div class="spinner"></div>
    <br />
    Loading...
  </div> -->
  <!-- Preloader -->
  <div class="loader-mask" *ngIf="loader == true">
    <div class="loader">
        <div></div>
        <div></div>
    </div>
</div>
<!-- Preloader -->
  <div class="loginLeft">
    <div class="logInParts">
      <div class="row sideLoginPart">
        <div class="col col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 title">
          <img class="logo" src="./assets/images/stag_logo.png" alt="logo">
        </div>
      </div>
      <div class="sideLoginPart topSignIn">
        <div class="row full-width leftPanelTop card  p-3 mb-2 h-100 minht100per formDiv">
          <form novalidate (ngSubmit)="loginFormSubmit(user)" method="post" id="login-form" class="form-group">
            <div class="form-header title text-align-center text-color-white cursorArrow" id="loginCardTitle">{{ 'loginSignIn' | translate }}</div>
            <div height="16px" class="form-gap-div"></div>
            <div class="form-element">
              <div class="form-element-input">
                <input type="text" id="email" name="email" class="form-input-feild" value="" [(ngModel)]="user.name"
                  [placeholder]="'phUserName'| translate" required>
              </div>
            </div>
            <div class="form-element">
              <div class="form-element-input">
                <input type="password" id="password" name="password" class="form-input-feild" value=""
                  [(ngModel)]="user.password" [placeholder]="'phPassword'| translate" required>
              </div>
            </div>
            <button type="submit" [ngClass]="{ dis: disLoginBtn == true }" (ngSubmit)="loginFormSubmit(user)"
              id="login-form-submit" class="form-submit-button">{{ 'loginBt' | translate }}&nbsp;&nbsp;
              <fa-icon class="fa fa-spin icon-black loginspinner" [icon]="faSpinner"></fa-icon>
            </button>
            <div class="form-account text-color-white">
              <a routerLink="/register" class="form-account-options" id="loginCreateAccount">
                {{ 'createAccount' | translate }}
              </a>
              <a (click)="goToResetPassword(user.name)" routerLink="/forgotpassword"
                class="form-account-options align_right" id="loginForgotPassword">
                {{ 'forgotPwd' | translate }}
              </a>
            </div>
            <div>
              <div class="text-message textClrWhite" id="loginResponse">{{toastMsg}}</div>
            </div>
          </form>
        </div>
      </div>

      <div class="sideLoginPart">
        <div class="login-footer">
          <a href="" class="form-account-options">{{ 'termsOfService' | translate }}</a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">{{ 'privacyPolicy' | translate }}</a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">{{ 'security' | translate }}</a>
        </div>
        <div class="row">
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-align-center">
            <!-- <select #langSelect (change)="translate.use(langSelect.value);updateLanguage(langSelect.value)">
              <option *ngFor="let lang of languages" [value]="lang.short"
                [selected]="lang.short === translate.currentLang">
                {{ lang.fullform }}
              </option>
            </select> -->
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="loginSecondPart">
    <div class="logInParts">
      <div class="loginRightSide">
        <div class="centerImage">
          <img src="../assets/images/1.png">
        </div>
      </div>
    </div>
  </div>
</div>